import Image from 'next/image';

import { ExternalLink } from '@/ui/Link/ExternalLink';

import { routes } from '@/utils/routes';

import {
  CheckMarkList,
  StyledH2,
  StyledParagraph,
  StyledPrimaryCell,
} from '../../SwapTokens/utils';
import styles from './styles.module.css';

const MEV_PROTECTION_BLOG_POST = `${routes.BLOG}/article/mev-protection`;

const DEFAULT_ITEMS = [
  'Save on slippage and cut down opportunity cost.',
  'Minimize failed trades with less than 1% reverts.',
  'Unbeatable trade rates with priority execution.',
];

export function MatchaAutoBenefitsSection({
  itemsText = DEFAULT_ITEMS,
  fasterOnChainText = `Timing is everything. Get privileged access to private market makers and beat the market
  with fast, efficient execution.`,
}) {
  return (
    <div className="desktop:flex gap-5 max-w-[1240px] mx-auto">
      <StyledPrimaryCell
        className={`${styles.mevProtectionCell} flex-col tablet:flex-row desktop:flex-col items-center desktop:justify-evenly py-16 tablet:py-20 tablet:px-32 desktop:pr-12 desktop:pl-20`}
      >
        <Image
          src="/images/swap-tokens/shield.svg"
          className="mt-3 mb-[52px] tablet:ml-7 tablet:mr-9"
          alt=""
          width={132}
          height={134}
        />
        <div className="tablet:ml-24 desktop:ml-0 text-center tablet:text-left desktop:text-center">
          <StyledH2>MEV protection</StyledH2>
          <StyledParagraph>
            Say goodbye to sandwich attacks and frontrunning. Protect from MEV without a second
            thought.{' '}
            <ExternalLink className="underline" href={MEV_PROTECTION_BLOG_POST}>
              Learn more.
            </ExternalLink>
          </StyledParagraph>
        </div>
      </StyledPrimaryCell>
      <StyledPrimaryCell
        className={`${styles.tradingCell} flex-col tablet:flex-row desktop:flex-col items-center tablet:justify-start desktop:justify-center py-20 desktop:pt-16 tablet:px-32 desktop:px-12`}
      >
        <Image
          src="/images/matcha-auto/trade-logo.png"
          className="mb-12 tablet:mb-0 desktop:mb-12 tablet:mr-24 desktop:mr-0"
          alt=""
          width={180}
          height={148}
        />
        <div className="max-w-[270px] tablet:ml-3 desktop:ml-0">
          <StyledH2 className="text-center tablet:text-left desktop:text-center mb-8">
            Get more than you pay for
          </StyledH2>
          <CheckMarkList items={itemsText} />
        </div>
      </StyledPrimaryCell>

      <StyledPrimaryCell
        className={`${styles.lightningCell} flex-col tablet:flex-row desktop:flex-col items-center pt-12 tablet:py-20 pb-20 gap-20`}
      >
        <Image
          src="/images/matcha-auto/lightning-logo.png"
          className="tablet:mr-24 desktop:mr-0 desktop:order-2"
          alt=""
          width={180}
          height={148}
        />
        <div className="tablet:ml-2 desktop:ml-0 text-center tablet:text-left desktop:text-center">
          <StyledH2 className="text-center tablet:text-left desktop:text-center mb-8">
            Faster onchain trading
          </StyledH2>
          <StyledParagraph>{fasterOnChainText}</StyledParagraph>
        </div>
      </StyledPrimaryCell>
    </div>
  );
}
